module.exports = "/images/motoicon.svg?9a5d3985776a70b549771c452395420b";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/motoicon.svg
// module id = TdtL
// module chunks = 1